import { withTheme } from 'styled-components'

export const HeaderIconInfo = withTheme((props) => (
	<svg {...props} width='121' height='128' viewBox='0 0 121 128' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M60.5 128C93.9132 128 121 100.733 121 67.0968C121 33.4608 93.9132 6.19354 60.5 6.19354C27.0868 6.19354 0 33.4608 0 67.0968C0 100.733 27.0868 128 60.5 128Z'
			fill='#005E5D'
		/>
		<mask id='mask0_2807_34427' maskUnits='userSpaceOnUse' x='0' y='0' width='121' height='128'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M121 0H0V66.6016V83.252H2.25107C9.40246 109.071 32.773 128 60.5 128C88.227 128 111.598 109.071 118.749 83.252H121V66.6016V0Z'
				fill='white'
			/>
		</mask>
		<g mask='url(#mask0_2807_34427)'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M86.5103 0.447661C89.3161 0.078808 92.2974 1.23344 94.4967 3.00969C96.696 4.78595 97.9222 7.02946 98.1566 9.85379L108.237 155.59C108.611 161.62 104.046 166.831 98.0293 167.243L28.395 172.228C22.3805 172.678 17.1514 168.167 16.7023 162.143L6.816 16.9534C6.44164 10.9235 10.859 5.84431 16.876 5.4325L86.5103 0.447661Z'
				fill='url(#paint0_linear_2807_34427)'
				fillOpacity='0.5'
			/>
			<path
				d='M15.1084 12C15.1084 6.47715 19.5855 2 25.1084 2H95.8918C101.415 2 105.892 6.47715 105.892 12V159.355C105.892 164.878 101.415 169.355 95.8917 169.355H25.1084C19.5855 169.355 15.1084 164.878 15.1084 159.355V12Z'
				fill='url(#paint1_linear_2807_34427)'
				stroke='#004C4C'
				strokeWidth='4'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M48.3999 14.4516C48.3999 13.3114 49.3242 12.3871 50.4644 12.3871H70.5354C71.6756 12.3871 72.5999 13.3114 72.5999 14.4516C72.5999 15.5918 71.6756 16.5161 70.5354 16.5161H50.4644C49.3242 16.5161 48.3999 15.5918 48.3999 14.4516Z'
				fill='#004C4C'
			/>
			<mask id='mask1_2807_34427' maskUnits='userSpaceOnUse' x='13' y='0' width='95' height='172'>
				<path
					d='M15.1084 12C15.1084 6.47715 19.5855 2 25.1084 2H95.8918C101.415 2 105.892 6.47715 105.892 12V159.355C105.892 164.878 101.415 169.355 95.8917 169.355H25.1084C19.5855 169.355 15.1084 164.878 15.1084 159.355V12Z'
					fill='url(#paint2_linear_2807_34427)'
					stroke='#004C4C'
					strokeWidth='4'
				/>
			</mask>
			<g mask='url(#mask1_2807_34427)'>
				<path
					opacity='0.3'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M107.892 0L13.1084 172.387V0H107.892Z'
					fill='#808080'
				/>
			</g>
		</g>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M58.2374 98.0646C72.7165 98.0646 84.4541 86.0485 84.4541 71.2259C84.4541 56.4032 72.7165 44.3871 58.2374 44.3871C43.7584 44.3871 32.0208 56.4032 32.0208 71.2259C32.0208 86.0485 43.7584 98.0646 58.2374 98.0646Z'
			fill='#005E5D'
			fillOpacity='0.3'
		/>
		<path
			d='M61.2623 94.9678C75.7414 94.9678 87.479 82.9517 87.479 68.1291C87.479 53.3064 75.7414 41.2903 61.2623 41.2903C46.7833 41.2903 35.0457 53.3064 35.0457 68.1291C35.0457 82.9517 46.7833 94.9678 61.2623 94.9678Z'
			fill='white'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M61.2244 58.7732C59.5755 58.7732 58.2373 57.4026 58.2373 55.7092C58.2373 54.0179 59.5755 52.6452 61.2244 52.6452C62.8752 52.6452 64.2114 54.0179 64.2114 55.7092C64.2114 57.4026 62.8752 58.7732 61.2244 58.7732Z'
			fill='#005CDE'
		/>
		<rect x='58.2373' y='62.9678' width='5.97413' height='19.6096' rx='2' fill='#005CDE' />
		<defs>
			<linearGradient
				id='paint0_linear_2807_34427'
				x1='-15.4532'
				y1='85.9026'
				x2='97.9967'
				y2='136.215'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopOpacity='0.13' />
				<stop offset='1' stopOpacity='0.28' />
			</linearGradient>
			<linearGradient
				id='paint1_linear_2807_34427'
				x1='62.5314'
				y1='-58.0415'
				x2='-42.4779'
				y2='6.97034'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#00C5BC' />
				<stop offset='1' stopColor='#009286' />
			</linearGradient>
			<linearGradient
				id='paint2_linear_2807_34427'
				x1='62.5314'
				y1='-58.0415'
				x2='-42.4779'
				y2='6.97034'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#00C5BC' />
				<stop offset='1' stopColor='#009286' />
			</linearGradient>
		</defs>
	</svg>
))
